import { HttpClient, HttpStatusCode } from 'data/protocols/http';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { StudentsCountUseCaseInterface } from 'domain/usecases';

export class RemoteStudentsCount implements StudentsCountUseCaseInterface {
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient<StudentsCountUseCaseInterface.Result>,
  ) {}

  async execute(
    params: StudentsCountUseCaseInterface.Params,
  ): Promise<StudentsCountUseCaseInterface.Result> {
    const httpResponse = await this.httpClient.request({
      method: 'get',
      url: this.url + params.id + '/overview/students-count',
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.forbidden:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError(httpResponse.body.message);
    }
  }
}
